class CartNotification extends HTMLElement {
    constructor() {
      super();

      this.overlay = this.querySelector('#CartNotification-Overlay')
      this.overlay?.addEventListener('click', this.close.bind(this));
      this.notification = this.querySelector('#cart-notification');
      this.onBodyClick = this.handleBodyClick.bind(this);

      if (!this.notification) return;
  
      this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
        closeButton.addEventListener('click', this.close.bind(this))
      );
    }
  
    open() {
      if (!this.notification || !this.overlay) return;
      this.notification.classList.add('open');
      this.overlay.classList.add('open');
  
      this.notification.addEventListener('transitionend', () => {
        this.notification.focus();
        trapFocus(this.notification);
      }, { once: true });
  
      document.body.classList.add('hidden');
      document.body.addEventListener('click', this.onBodyClick);
    }
  
    close() {
      this.notification?.classList.remove('open');
      this.overlay?.classList.remove('open');
      document.body.classList.remove('hidden');
      document.dispatchEvent(new CustomEvent('body:visible'));
      document.body.removeEventListener('click', this.onBodyClick);
      removeTrapFocus(this.activeElement);
    }
  
    renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
          const sectionHTML = parsedState.sections?.[section.id];
          if (!sectionHTML) return;
          if(section.id == 'cart-drawer') {
            if(document.querySelector(section.selector)) {
              const elementCartDrawer = document.querySelector(section.selector)
              const drawerContent = this.getSectionInnerHTML(sectionHTML, section.selector);
              if (drawerContent !== null) elementCartDrawer.innerHTML = drawerContent;
            }
            const notificationHTML = 'cart-drawer';
            const elementNotification = `[id="cart-notification-product-${this.cartItemKey}"]`;
            const notificationWrapper = document.getElementById('cart-notification-wrapper');
            const notificationContent = this.getSectionInnerHTML(parsedState.sections?.[notificationHTML], elementNotification);
            if (notificationWrapper && notificationContent !== null) notificationWrapper.innerHTML = notificationContent;
          } else {
            if(document.querySelector(section.selector)) {
              const elements = document.querySelectorAll(section.selector)
              const sectionContent = this.getSectionInnerHTML(sectionHTML, section.selector);
              if (sectionContent === null) return;
              Array.from(elements).forEach(element => {
                element.innerHTML = sectionContent;
              })
            }
          }  
      }));
      this.open();
    }
  
    getSectionsToRender() {
      let arraySections = []
      if (window.innerWidth > 920 && document.querySelector('.header-without-sidebars')) {
        arraySections = [
          {
              id: 'cart-drawer',
              selector: '#CartDrawer'
            },
          {
              id: 'menu-drawer',
              selector: '#cart-icon-bubble-menu-drawer'
            },
            {
              id: 'header',
              selector: '#cart-icon-bubble-header'
            },
            {
              id: 'secondary-sidebar',
              selector: '#cart-icon-bubble-secondary-sidebar'
            },
            {
              id: 'main-sidebar',
              selector: '#cart-icon-bubble-main-sidebar'
            }
        ];
      } else if (window.innerWidth > 920 && document.querySelector('.secondary-header-section')) {
      arraySections = [
        {
              id: 'cart-drawer',
              selector: '#CartDrawer'
            },
          {
              id: 'menu-drawer',
              selector: '#cart-icon-bubble-menu-drawer'
            },
            {
              id: 'secondary-header',
              selector: '#cart-icon-bubble-secondary-header'
            },
            {
              id: 'secondary-sidebar',
              selector: '#cart-icon-bubble-secondary-sidebar'
            },
            {
              id: 'main-sidebar',
              selector: '#cart-icon-bubble-main-sidebar'
            }
      ];
    } else {
        arraySections = [
          {
              id: 'cart-drawer',
              selector: '#CartDrawer'
            },
          {
              id: 'menu-drawer',
              selector: '#cart-icon-bubble-menu-drawer'
            },
            {
              id: 'mobile-header',
              selector: '#cart-icon-bubble-mobile-header'
            }
        ];
      }
      return arraySections
    }
  
    getSectionInnerHTML(html, selector = '.shopify-section') {
      if (!html) return null;
      const source = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector);
      return source?.innerHTML ?? null;
    }
  
    handleBodyClick(evt) {
      const target = evt.target;
      if (target instanceof Element && target !== this.notification && !target.closest('cart-notification')) {
        const disclosure = target.closest('details-disclosure, header-menu');
        this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
        this.close();
      }
    }
  
    setActiveElement(element) {
      this.activeElement = element;
    }
  }
  
  if (!customElements.get('cart-notification')) customElements.define('cart-notification', CartNotification);
